import './App.css';
import ShineOneEstate from './idea1.jsx';
import AdminPanel from './admin.jsx';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ShineOneEstate />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </Router>
  );
}

export default App;
